import { Box, Divider, Typography } from '@mui/material';
import React from 'react';
import BackButton from '../../../components/Buttons/BackButton';
import Theme from '../../../Themes/main.theme';
import { useNavigate } from 'react-router-dom';

interface TitlePageProps {
    title: string
    backButton: boolean
}

const TitlePage = (props: TitlePageProps) => {
  const {title, backButton = false} = props;
  const navigate = useNavigate();

  return (
    <>
      {backButton ? 
        <Box mt={2} mb={2}>
          <BackButton onClick={() => navigate(-1)}/>
        </Box>
        : null}  
      <Typography variant='h2' sx={{my: 2}}
        color={Theme?.labelColor?.main}>{title}
      </Typography>
      <Divider sx={{ mb: 5, border: 1, color: Theme?.dividerColor?.main }} />

    </>
  );
};

export default TitlePage;